import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, Input, Button, Select, Upload, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import styles from "./styles.module.less";
import { Link } from "react-router-dom";
import { UploadFile } from "antd/es/upload/interface";
import Axios from "axios";
// import { basePath } from "../../utils/index";

const { Option } = Select;

export const ProblemForm = () => {
  const [typeProblem, setTypeProblem] = useState(0);
  const [uploadUrl, setUploadUrl] = useState();
  const onFinish = (value: any) => {
    const params = {
      type: typeProblem,
      description: value.description,
      phone: value.phone,
      images: uploadUrl,
      appId: window.__appId__,
    };
    postFeedBack(params);
  };
  const { t } = useTranslation();
  const validateMessages = {
    // eslint-disable-next-line
    required: t("common.problem.verifyTip"),
  };
  const typeOperations = [
    {
      label: t("common.problem.noVerify"),
      value: 0,
    },
    {
      label: t("common.problem.noLogin"),
      value: 1,
    },
    {
      label: t("common.problem.noRegister"),
      value: 2,
    },
    {
      label: t("common.problem.noAccount"),
      value: 3,
    },
    {
      label: t("common.problem.noResetPass"),
      value: 4,
    },
    {
      label: t("common.problem.other"),
      value: 5,
    },
  ];
  const typeProblemMap: any = {
    0: [
      t("common.problem.noVerifyTip.tip"),
      t("common.problem.noVerifyTip.type1"),
      t("common.problem.noVerifyTip.type2"),
      t("common.problem.noVerifyTip.type3"),
    ],
    1: [t("common.problem.noLoginTip.tip"), t("common.problem.noLoginTip.type1"), t("common.problem.noLoginTip.type2")],
    2: [
      t("common.problem.noRegisterTip.tip"),
      t("common.problem.noRegisterTip.type1"),
      t("common.problem.noRegisterTip.type2"),
      t("common.problem.noRegisterTip.type3"),
    ],
    3: [
      t("common.problem.noAccountTip.tip"),
      t("common.problem.noAccountTip.type1"),
      t("common.problem.noAccountTip.type2"),
    ],
    4: [
      t("common.problem.noResetPassTip.tip"),
      t("common.problem.noResetPassTip.type1"),
      t("common.problem.noResetPassTip.type2"),
    ],
    5: [t("common.problem.otherTip.tip"), t("common.problem.otherTip.type1")],
  };
  const postSuccess = () => {
    Modal.success({
      title: t("common.problem.successTip"),
      content: t("common.problem.successTipMsg"),
      onOk() {
        window.location.href = "/login";
      },
    });
  };
  const postFeedBack = async (params: any) => {
    const { code } = await Axios.post("/api/v2/feedback", params);
    if (code === 200) {
      postSuccess();
    }
  };
  const typeProblemBlock = () => {
    return (
      <div>
        {typeProblemMap[typeProblem]?.map((item: any, index: any) => (
          <div key={index}>{item}</div>
        ))}
      </div>
    );
  };

  const UploadImg = () => {
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState();
    const [fileList, setFileList] = useState<UploadFile<any>[]>([]);
    const handleChange = (info: any) => {
      setFileList(info.fileList);
      const imgUrl = info.fileList.map((item: any) => {
        const response = item.response;
        return response?.data.url;
      });
      console.log(imgUrl);
      setUploadUrl(imgUrl);
    };
    const handleCancel = () => {
      setPreviewVisible(false);
    };

    const handlePreview = async (file: any) => {
      setPreviewImage(file.url);
      setPreviewVisible(true);
    };
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>{t("common.problem.form.upload")}</div>
      </div>
    );
    return (
      <>
        <Upload
          action="/api/v2/upload?folder=photos"
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          onChange={handleChange}
        >
          {fileList.length >= 8 ? null : uploadButton}
        </Upload>
        <Modal visible={previewVisible} title="title" footer={null} onCancel={handleCancel}>
          <img alt="example" style={{ width: "100%" }} src={previewImage} />
        </Modal>
      </>
    );
  };
  return (
    <Form name="" onFinish={onFinish} validateMessages={validateMessages} colon={false}>
      <Form.Item
        name={"phone"}
        label={t("common.problem.form.phone")}
        rules={[{ required: true }]}
        style={{ marginLeft: -11 }}
      >
        <Input placeholder={t("common.problem.form.phonePlaceholder")} style={{ width: 330 }} />
      </Form.Item>
      <Form.Item name="type" label={t("common.problem.form.question")}>
        <Select
          onChange={(value) => {
            setTypeProblem(value);
          }}
          style={{ width: 330 }}
          defaultValue={typeProblem}
        >
          {typeOperations?.map(({ value, label }) => (
            <Option key={value} value={value}>
              {label}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <div className={styles.typeProblem}>{typeProblemBlock()}</div>
      <div className={styles.label}>{t("common.problem.form.questionDescript")}</div>
      <Form.Item name={"description"}>
        <Input.TextArea />
      </Form.Item>
      <div className={styles.uploadImgWarp}>
        <div className={styles.label}>{t("common.problem.form.questionClip")}</div>
        {UploadImg()}
      </div>
      <Form.Item>
        <Button type="primary" htmlType="submit" block>
          {t("common.problem.form.submit")}
        </Button>
      </Form.Item>
    </Form>
  );
};

export const ProblemPage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.problemPage}>
      <div className={styles.title}>{t("common.problem.title")}</div>
      <ProblemForm />
      <div className={styles.bottom}>
        {t("common.problem.noProblem")}
        <Link to="/login">{t("common.problem.goLogin")}</Link>
      </div>
    </div>
  );
};
